"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const StringArrayEncoding_1 = require("../../enums/StringArrayEncoding");
exports.StringArrayEncodingRule = (options) => {
    if (options.stringArrayEncoding === true) {
        options = Object.assign(Object.assign({}, options), { stringArrayEncoding: StringArrayEncoding_1.StringArrayEncoding.Base64 });
    }
    return options;
};
